import { JsonProperty } from 'json-typescript-mapper';
import {Contact, Marketdate, Marketday} from './';
import {Log} from './log.model';

export enum MessageType {
  Note = <any>'Note',
  Announcement = <any>'Announcement',
  BranchNoteInternal = <any>'BranchNoteInternal',
  DepositReceipt = <any>'DepositReceipt',
}

export enum MessageActionType {
  NONE = <any>'None',
  COMMENT = <any>'Comment',
  EMAIL = <any>'Email',
}

export class Message {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('created')
  public created?: any;

  @JsonProperty('updated')
  public updated?: any;

  @JsonProperty({clazz: Marketdate, name: 'marketdate'})
  public marketdate?: Marketdate;

  @JsonProperty('createdBy')
  public createdBy?: Contact;

  @JsonProperty('content')
  public content?: string;

  @JsonProperty('read')
  public read?: boolean;

  @JsonProperty('messageType')
  public messageType?: MessageType;

  @JsonProperty({clazz: Marketday, name: 'marketday'})
  public marketday?: Marketday;

  @JsonProperty('marketdates')
  public marketdates?: Marketdate[];

  @JsonProperty('image')
  public image?: string;

  @JsonProperty('imageUploaded')
  public imageUploaded?: boolean;

  @JsonProperty('actionCreated')
  public actionCreated?: Date;

  @JsonProperty('actionCreatedBy')
  public actionCreatedBy?: Contact;

  @JsonProperty('actionComment')
  public actionComment?: string;

  @JsonProperty('actionType')
  public actionType?: MessageActionType;

  @JsonProperty('actionEmail')
  public actionEmail?: Log;

  constructor() {
    this.id = void 0;
    this.created = void 0;
    this.updated = void 0;
    this.marketdate = void 0;
    this.createdBy = void 0;
    this.content = void 0;
    this.read = void 0;
    this.messageType = void 0;
    this.marketday = void 0;
    this.marketdates = void 0;
    this.image = void 0;
    this.imageUploaded = void 0;
    this.actionCreated = void 0;
    this.actionCreatedBy = void 0;
    this.actionComment = void 0;
    this.actionType = void 0;
    this.actionEmail = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/message.model.ts